import {Redirect, Route, RouteProps} from 'react-router-dom';
import {Role} from '../../../const/auth';
import {ERROR_404_PAGE, LOGIN_PAGE} from '../../../const/routes';
import {useAppSelector} from '../../../hooks/customReduxHooks';
import {selectAuthUserData} from '../../../store/auth';
import useQuery from '../../../hooks/useQuery';
import {useEffect} from 'react';
import { setToken } from '../../../storage/storage';
import { isTokenValid } from '../../../utils/jwt';

type AuthRouteProps = RouteProps & {
    roles: Role[];
    withoutReturnUrl?: boolean;
};

const AuthRoute = ({roles, withoutReturnUrl, ...props}: AuthRouteProps) => {
    const authUserData = useAppSelector(selectAuthUserData);
    const userHasRoles = roles.includes(authUserData?.role);
    const query = useQuery();
    const token = query.get('token');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const getUrlParams = () => {
        if (window.location?.pathname && (!authUserData || token) && !withoutReturnUrl) {
            let queryParams = "";
            const returnUrl = encodeURIComponent(window.location.pathname);

            queryParams = `?returnUrl=${returnUrl}`;

            if(token) 
                queryParams += `&token=${token}`;

            return queryParams;
        }
        return '';
    };

    let children : React.ReactNode;

    if(token)
    {
        if(isTokenValid(token)) 
            children = <Redirect to={LOGIN_PAGE + getUrlParams()} />;
        else
            children = <Redirect to={ERROR_404_PAGE} />;
    }else if(userHasRoles)
    {
        children = props.children;
    }else
    {
        children = <Redirect to={LOGIN_PAGE + getUrlParams()} />;
    }

    return <Route {...props}>{children}</Route>;
};

export default AuthRoute;
